"use client"

import { HouseWifi } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HouseWifiIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HouseWifiIcon = component(Icon)({ as: HouseWifi })
